module.exports = "pegasus_template/assets/hexline-twitter-old.png";